export const TYPE_QUESTIONS = {
  SINGLE_SELECT: 'single_select',
  MULTIPLE_SELECT: 'multiple_select',
  RANGE: 'range',
  WRITTEN: 'written',
  PREFERENCE: 'preference',
  IMAGE_SELECT: 'image_select',
  TASK: 'task',
  FIRST_CLICK: 'first_click_test',
  RANKING: 'ranking',
  MATRIX: 'matrix',
  FIVE_SECOND: 'five_second',
};
